/* eslint-disable jsx-a11y/label-has-associated-control */
import "./styles.css";
import clsx from "clsx";

interface IProps {
  checked: boolean;
  onChange: (event: any) => void;
  label?: string;
  labelClasses?: string;
}

function Switch({ checked = false, onChange, label, labelClasses = "" }: IProps) {
  return (
    <div className="flex items-center gap-2">
      <label className={clsx("font-satoshi font-semibold accent-secondary", labelClasses)}>{label}</label>
      <label className="switch">
        <input type="checkbox" className="" checked={checked} onChange={onChange} />
        <span className="slider round" />
      </label>
    </div>
  );
}

export default Switch;
